import React, { Component } from "react";
import RuedaService from "../../../services/rueda/RuedaService";
import { trackPromise } from "react-promise-tracker";
import DataTable from "react-data-table-component";
import Popup from "react-popup";
import MensajeUsuario from "../../generico/MensajeUsuario";
import history from "../../pages/login/history";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class Rueda3 extends Component {
  constructor(props) {
    super(props);
  }

  //TODO, codigo 105 error, nro de contrato ya seleccionado

  notifiPopup = (titulo, mensaje, callback) =>

    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              callback();
              //history.push("/adquisicionrueda");
              history.push(ConfigService.getPathByName("adquisicionRueda")?.url);
              window.location.reload();
              Popup.close();
            },
          },
          // {
          //   text: "Aceptar",
          //   className: "success",
          //   action: function () {
          //     history.push("/adquisicionrueda");
          //     window.location.reload();
          //     Popup.close();
          //   },
          // },
        ],
      },
    });

  componentDidMount() {
    this.getDatosCuenta();
    this.getDatosGrupo();
  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      },
    ];
  }

  getDatosCuenta() {
    var respuesta = [
      {
        concepto: "Nro. de Contrato:",
        valor:
          this.props.porSuerte
            ? "SELECCIONADO AL AZAR"
            : this.props.nroContrato,
      },
      { concepto: "Estado:", valor: "PENDIENTE" },
      {
        concepto: "Fecha del 1° Vencimiento de Cuota:",
        valor: this.props.grupo.fechaModulo,
      },
      {
        concepto: "Fecha de Vencimiento de la Cuenta:",
        valor: this.props.grupo.fechaVencimiento,
      },
      {
        concepto: "Total a Debitar:",
        valor: this.props.grupo.importeTotalDebito,
      },
      { concepto: "Importe Cuota:", valor: this.props.grupo.importeCuota },
    ];

    return respuesta;
  }
  getDatosGrupo() {
    var respuesta = [
      { concepto: "Plan:", valor: this.props.grupo.plan },
      { concepto: "Cantidad de Socios:", valor: this.props.grupo.cantSocio },
      { concepto: "Cantidad de Cuotas:", valor: this.props.grupo.cantCuota },
      { concepto: "Importe de Cuotas:", valor: this.props.grupo.importeCuota },
      { concepto: "Estado:", valor: this.props.grupo.estado },
      { concepto: "Adquisición:", valor: this.props.grupo.adquisicion },
      { concepto: "Fecha de Inicio:", valor: this.props.grupo.fechaInicio },
    ];

    return respuesta;
  }
  confirmar = () => {
    //// bloquea boton
    this.btn.setAttribute("disabled", "disabled");

    trackPromise(
      RuedaService.confirmarCompraRueda(
        this.props.cuentaOrigen.value,
        this.props.porSuerte ? "99999" : this.props.nroContrato,
        this.props.grupo.plan
      ).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        //TODO valor de prueba
        //jData.codigo = jData.codigo === "0" ? "105" : jData.codigo;

        if (jData.codigo === "0") {
          this.props.returnDataPaso3(jData.numeroOperacion, jData.contrato, jData.nombreSucursal, jData.cuentaAsignada, jData.pdfContrato);
          this.nextStep.click();
          this.btn.removeAttribute("disabled");
        } else {
          //// Habilita boton
          this.btn.removeAttribute("disabled");
          if (jData.codigo === "105") {
            Popup.queue(this.notifiPopup("Info", jData.mensaje, () => {
              this.props.actualizarNoDisponibles(this.props.nroContrato);
              this.props.goToStep(2);
            }));
          } else {
            Popup.queue(this.notifiPopup("Info", jData.mensaje, () => {
              history.push("/adquisicionrueda");
              window.location.reload();
            }));
          }
        }
      })
    );
  };
  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Número de Contrato</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label className="input-label">Cuenta Origen (a debitar):</label>
              <br />
              <label className="input-label-bold">
                {this.props.cuentaOrigen.label}
              </label>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 table-responsive">
            <div className="invoice p-3 mb-3">
              <div className="row">
                <div className="col-12">
                  <h5>Datos del Grupo/Plan</h5>
                </div>
              </div>
              <div className="row">
                <DataTable
                  noHeader={true}
                  columns={this.getColumn()}
                  data={this.getDatosGrupo()}
                  dense={true}
                  noDataComponent="ingrese un número de contrato para mostrar la información"
                  responsive={true}
                  noTableHead={true}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 table-responsive">
            <div className="invoice p-3 mb-3">
              <div className="row">
                <div className="col-12">
                  <h5>Datos de la cuenta</h5>
                </div>
              </div>
              <div className="row">
                <div className="table-responsive">
                  <DataTable
                    noHeader={true}
                    columns={this.getColumn()}
                    data={this.getDatosCuenta()}
                    dense={true}
                    noDataComponent="ingrese un número de contrato para mostrar la información"
                    responsive={true}
                    noTableHead={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row invoice-info">
          <div className="col-12">
            <MensajeUsuario tipo="INFO"
              titulo="Importante."
              mensaje="Hasta un contrato por socio y por grupo, en la primera semana de
                          apertura. Reglamento disponible en la página web y en las
                          sucursales."
              mensaje2="Acepto las bases y condiciones definidas en el contrato." />
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-lg-8 col-md-6">
              <label
                className="input-label-bold"
                style={{ marginTop: 10 }}
              >
                ¿Está seguro que desea CONFIRMAR la operación?
                <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-3 btn-consulta">
              <button
                className="btn btn-cu-quintary"
                onClick={this.props.previousStep}
              >
              <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>
          </div>
          <div className="col-lg-2 col-md-3">
          <button ref={btn => { this.btn = btn; }}
                className="btn btn-cu-primary"
                onClick={() => {
                  this.confirmar();
                }}
              >
                {" "}
                Confirmar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
          </div>
        </div>
      </div>
    );
  }
}
